import { TipJar } from "@/components/TipJar";

export default function Support() {
  return (
    <div className="max-w-6xl mx-auto px-5 lg:px-10 py-14 lg:py-20 grid lg:grid-cols-12 gap-12" data-testid="support-page">
      <div className="lg:col-span-6">
        <p className="overline text-[#0A0A0A]">Support independent intelligence</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold mt-3 leading-[1.05]">Africa is not a footnote. Help us keep it that way.</h1>
        <p className="text-[#575757] mt-6 leading-relaxed">We do not sensationalise. We do not simplify. Reader contributions fund field reporting, data collection and the time it takes to get the story right — from farm gate to export shelf.</p>
      </div>
      <div className="lg:col-span-5 lg:col-start-8"><TipJar /></div>
    </div>
  );
}
